import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from '../../utils/i18n';
import {documentCollectionType, issueAttributesType} from '../../constants/proptype-validation';
import Label from '@adsk/bim360-matrix-react-label';
import {viewTypes} from '../../constants/view-types';
import {getLinkedDocument} from '../../utils/issues-helpers';
import DocumentDisplayName from './DocumentDisplayName';

const LinkedDocumentInlineEdit = ({issue, viewType, documentCollection, className, container, contentElementRef}) => {
  const showHyperlink = viewType === viewTypes.PROJECT;
  const isDocument = viewType === viewTypes.DOCUMENT;
  const issueId = issue.id;
  const {urn, createdAtVersion} = getLinkedDocument(issue);
  const document = documentCollection[urn];

  return (
    <div className={classNames('LinkedDocumentInlineEdit', className)}>
      <div className="LinkedDocumentInlineEdit__label">
        <Label>{i18n.t('issueAttributes.document.label')}</Label>
      </div>
      <div
        className="LinkedDocumentInlineEdit__document-details"
        data-testid="LinkedDocumentInlineEdit__document-details"
      >
        <DocumentDisplayName
          issue={issue}
          issueTargetUrn={urn}
          document={document}
          issueCreatedAtVersion={createdAtVersion}
          issueId={issueId}
          showHyperlink={showHyperlink}
          container={container}
          allowOnlyUnlink={isDocument}
          contentElementRef={contentElementRef}
        />
      </div>
    </div>
  );
};

LinkedDocumentInlineEdit.displayName = 'LinkedDocumentInlineEdit';

LinkedDocumentInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  documentCollection: documentCollectionType,
  viewType: PropTypes.string.isRequired,
  container: PropTypes.object,
  className: PropTypes.string,
  contentElementRef: PropTypes.object
};

export default LinkedDocumentInlineEdit;
